import styled from "styled-components";
import { SxProps, Theme } from "@mui/material";

export const NameVariable = styled.div<{ theme?: any }>`
  display: block;
`;

export const modalFormLayoutSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  maxHeight: "calc(100vh - 92px)",
  "& > :first-of-type": {
    paddingBottom: "8px",
  },
};

export const modalFormBodySx: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
};
